import utils from "@utils";
import { PaymentService } from "@services";
import { apiErrorHandler } from "@redux-core/utils";
import Actions from ".";

// authwrapper
export const getPaymentMethods = () => dispatch => {
	const { lang } = global;
	dispatch(Actions.setLoading("paymentMethods", true));

	PaymentService.getData()
		.then(({ data }) => {
			dispatch(Actions.setLoading("paymentMethods", false));
			if (data)
				dispatch(Actions.setPaymentMethods(data.UserId, utils.extractPaymentMethods(data)));
		})
		.catch(error =>
			apiErrorHandler({
				dispatch,
				module: "app",
				property: ["loading", "paymentMethods"],
				defaultMessage: lang.t("Error loading Payment Methods"),
				hideAlert: error.response && error.response.status === 404,
			})(error),
		);
};

export default {
	getPaymentMethods,
};
